import { BEAchievementLimit } from "types/achievements";
import { ItemCriteriaParam, SelectedLimitType } from "types/campaigns";

export enum AchievementRuleTypes {
  DIRECT = "direct",
  REFERRAL = "referral",
}

export type AchievementRuleTypeUnion = `${AchievementRuleTypes}`;

export enum AchievementTriggers {
  TRANSACTION = "transaction",
  CUSTOM_EVENT = "custom_event",
}

export type AchievementTriggersUnion = `${AchievementTriggers}`;

export enum AchievementAggregation {
  QUANTITY = "quantity",
  EXPRESSION = "expression",
}

export type AchievementAggregationUnion = `${AchievementAggregation}`;

export enum AchievementCompleteRulePeriod {
  // "non consecutive"
  OVERALL = "overall",
  LAST_DAY = "last_day",
  // "consecutive"
  DAY = "day",
  WEEK = "week",
  MONTH = "month",
  YEAR = "year",
  // only for FE
  STREAK = "streak",
}

export type AchievementCompleteRulePeriodUnion =
  `${AchievementCompleteRulePeriod}`;

export type CompleteRule = {
  period: {
    consecutive?: number;
    type: AchievementCompleteRulePeriodUnion;
    value?: number;
    streakType?: AchievementCompleteRulePeriodUnion;
  };
  periodGoal: number;
  onlyUniqueAttributeValues?: boolean;
  uniqueAttribute?: string;
};

export interface BEAchievementRule {
  achievementRuleId?: string;
  aggregation: {
    type: AchievementAggregationUnion;
    rule?: string;
  };
  completeRule: CompleteRule;
  conditions: {
    attribute?: string;
    data: string | number | boolean | { from: string; to: string } | string[];
    operator: string;
  }[];
  // attribute "event" is required only when trigger="custom_event"
  event?: string;
  uniqueReferee?: boolean;
  trigger: AchievementTriggersUnion;
  type: AchievementRuleTypeUnion;
  limit: BEAchievementLimit;
  translations: {
    [key: string]: {
      description?: string;
      name: string;
    };
  };
}

type FEAchievementCondition = {
  attribute: string;
  category?: string;
  counter?: number;
  data: string | number | boolean | { from: string; to: string } | string[];
  draft?: any;
  isEditing: boolean;
  isSaved: boolean;
  label?: string;
  operator: string;
  param?: string | ItemCriteriaParam[];
  type?: string;
};

export interface FEAchievementRule
  extends Omit<BEAchievementRule, "translations" | "limit" | "completeRule"> {
  conditions: FEAchievementCondition[];
  translations: { description?: string; locale?: string; name?: string }[];
  limit: SelectedLimitType;
  completeRule: CompleteRule & {
    draft?: CompleteRule;
    isEditing?: boolean;
  };
}

export interface FEAvailableAchievementAggregationType {
  aggregation: AchievementAggregationUnion;
  descriptionText: (trigger: AchievementTriggersUnion) => string;
  label: string;
}

export interface FEAvailableAchievementType {
  descriptionText: string;
  label: string;
  type: AchievementRuleTypeUnion;
}
